import {
  Context,
  Order,
  Customer,
  OrderLineItemDiscount,
} from '@squareup/sq-addons-web-sdk'

function getDiscounts(): OrderLineItemDiscount[] {
  return []

  // uncomment to simulate a discount
  // return [
  //   {
  //     uid: 'discount-id-1',
  //     name: `THANX 10% off`,
  //     type: 'FIXED_AMOUNT',
  //     scope: 'ORDER',
  //     appliedMoney: {
  //       amount: BigInt(498),
  //       currency: 'USD',
  //     },
  //     amountMoney: {
  //       amount: BigInt(498),
  //       currency: 'USD',
  //     },
  //     metadata: {
  //       offerId: 'r-l39CnP',
  //       redemptionId: 'j8v56v2hdrvqpo2',
  //     },
  //   },
  // ]
}

function getCustomer() {
  return undefined

  // uncomment to simulate a customer
  // return {
  //   address: {
  //     postalCode: '02482',
  //   },
  //   givenName: 'Noel',
  //   familyName: 'Euzebe',
  //   birthday: '1980-01-01',
  //   emailAddress: 'noel@thanx.com',
  //   referenceId: '022a453b4507',
  //   phoneNumber: '8085556421',
  // }
}

export const CONTEXT: Context = {
  configurations: {
    environmentUrl: 'https://loyalty.thanxsandbox.com/square',
    locationId: 'L8S9XEQZW5DT1',
    programId: '28925de8-8bb9-4c6f-bd44-4573d07c5b52',
    trainingMode: false,
    pointsCurrencySingular: 'point',
    pointsCurrencyPlural: 'points',
    scannerEnabled: false,
    enrollmentLinkEnabled: false,
  },
  device: { hasScanner: true, id: '27' },
  employee: { id: '04' },
}

export const ORDER: Order = {
  id: '2FtfMjYdP1ATbaMoyt74kh37Lb4F',
  locationId: 'L8S9XEQZW5DT1',
  lineItems: [
    {
      catalogObjectId: 'NkROs6O4slZ1NctAHS9W7B',
      quantity: '1',
      name: 'Breadfruit',
      basePriceMoney: {
        amount: BigInt(1000),
        currency: 'CAD',
      },
      grossSalesMoney: {
        amount: BigInt(1000),
        currency: 'CAD',
      },
      totalTaxMoney: {
        amount: BigInt(0),
        currency: 'CAD',
      },
      totalDiscountMoney: {
        amount: BigInt(0),
        currency: 'CAD',
      },
      totalMoney: {
        amount: BigInt(1000),
        currency: 'CAD',
      },
      variationTotalPriceMoney: {
        amount: BigInt(1000),
        currency: 'CAD',
      },
      itemType: 'ITEM',
      totalServiceChargeMoney: {
        amount: BigInt(0),
        currency: 'CAD',
      },
    },
  ],
  createdAt: '2024-10-16T15:46:15.869Z',
  updatedAt: '2024-10-16T15:46:15.869Z',
  state: 'OPEN',
  version: 1,
  totalTaxMoney: {
    amount: BigInt(0),
    currency: 'CAD',
  },
  totalDiscountMoney: {
    amount: BigInt(0),
    currency: 'CAD',
  },
  totalTipMoney: {
    amount: BigInt(0),
    currency: 'CAD',
  },
  totalMoney: {
    amount: BigInt(1000),
    currency: 'CAD',
  },
  totalServiceChargeMoney: {
    amount: BigInt(0),
    currency: 'CAD',
  },
  netAmounts: {
    totalMoney: {
      amount: BigInt(1000),
      currency: 'CAD',
    },
    taxMoney: {
      amount: BigInt(0),
      currency: 'CAD',
    },
    discountMoney: {
      amount: BigInt(0),
      currency: 'CAD',
    },
    tipMoney: {
      amount: BigInt(0),
      currency: 'CAD',
    },
    serviceChargeMoney: {
      amount: BigInt(0),
      currency: 'CAD',
    },
  },
  source: {
    name: 'Sandbox for sq0idp-5ebrFQVw1zsm53RH2PJMnQ',
  },
  customerId: 'S37NQ0XMRPBX527W5270B0T8KW',
  netAmountDueMoney: {
    amount: BigInt(1000),
    currency: 'CAD',
  },
  discounts: getDiscounts(),
}

export const CUSTOMER: Customer | undefined = getCustomer()
